<template>
    <router-view />
</template>

<script>
export default {
    name: 'ReceptionModule'
};
</script>
